import styled from "styled-components";

export default styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    cursor: pointer;

    padding-right: 10px;
    
    .agenda-item {
        border-left: 1px solid #efefef;
        padding-bottom: 5px;
    }

    .info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex-grow: 1;

        padding: 15px 15px;

        &.end {
            align-items: flex-end;
        }

        .name {
            display: flex;
            flex-direction: row;
            align-items: center;

            font-weight: bolder;
            letter-spacing: 0.1em;
            font-size: 16px;
            color: ${(props) => props.theme.homeListRowHeader};

            .lockedIcon {
                display: flex;

                font-size: 12px;
                margin-bottom: 4px;
                margin-left: 5px;
            }

            .activeBadge {
                display: flex;
                font-size: 10px;
                background-color: ${(props) =>
                        props.theme.accentButtonBackground};
                color: white;
                padding: 3px 5px;
                margin-left: 10px;
                margin-bottom: 3px;

                border-radius: 5px;
            }

            &.active {
                color: ${(props) => props.theme.accentButtonBackground};
            }
        }

        .details {
            display: flex;
            flex-direction: row;
            margin: 0 -5px;

            .detail {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 0 5px;

                p {
                    color: ${(props) => props.theme.homeListRowText};
                    font-size: 14px;
                }

                svg {
                    color: ${(props) => props.theme.homeListRowText};
                    font-size: 10px;
                    margin-right: 4px;
                    margin-bottom: 2px;
                }
            }
        }
    }

    .date {
        display: flex;
        flex-direction: column;
        justify-content: center;

        color: ${(props) => props.theme.homeListRowText};
        font-size: 14px;
        margin: 0 20px;
        white-space: nowrap;
    }

    .actions {
        .actionsMenuBtn {
            color: ${(props) => props.theme.tableIconHighlight};
        }
    }

    :hover {
        background-color: ${(props) => props.theme.homeListBodyBackgroundHover};
    }

    .order {
        margin: 0 10px;
    }

    .files {
        display: flex;
        flex-wrap: wrap;

        .file-wrapper {
            position: relative;
        }
        
        .file {
            padding: 0;
            height: 100px;
            width: 100px;
            margin-left: 15px;
            margin-right: 0;
        }
    }
`;
